/**
 * Delivery Risk Store — live copy of reports/deliveryRisk for the nav badge
 * and the report view. The server recomputes hourly and on Refresh.
 */
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { db } from '@/js/firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import { logger } from '@/services/loggerService';

export const useDeliveryRiskStore = defineStore('deliveryRisk', () => {
  const report = ref(null);
  const initialized = ref(false);
  let unsubscribe = null;

  const actionCount = computed(() => (report.value?.counts?.late || 0) + (report.value?.counts?.atRisk || 0));

  function init() {
    if (initialized.value) return;
    initialized.value = true;
    try {
      unsubscribe = onSnapshot(
        doc(db, 'reports', 'deliveryRisk'),
        (snap) => { report.value = snap.exists() ? snap.data() : null; },
        (error) => { logger.firestoreListenerError('[DeliveryRiskStore] Snapshot error', error); }
      );
    } catch (error) {
      logger.error('[DeliveryRiskStore] Failed to init', error);
    }
  }

  function teardown() {
    if (unsubscribe) { unsubscribe(); unsubscribe = null; }
    initialized.value = false;
    report.value = null;
  }

  return { report, actionCount, initialized, init, teardown };
});
